import React from 'react';
import { packItems } from '../data/landing';
export function PackSection() {
  return <section className="bg-cream py-14 md:py-28" data-id="element-95" data-mp="2ocd16ros66ug">
      <div className="mx-auto max-w-4xl px-5 md:px-8" data-id="element-96" data-mp="2odo3so6hp8jz">
        <h2 className="text-center font-serif text-[1.9rem] font-semibold leading-tight text-ink sm:text-4xl md:text-5xl" data-id="element-97" data-mp="2jd8pnuedvx0y">
          Todo lo que recibís en un solo pack
        </h2>
        <ol className="mt-8 overflow-hidden rounded-2xl border border-line bg-white md:mt-12" data-id="element-98" data-mp="2actu827ph1jq">
          {packItems.map(({
          icon: Icon,
          title,
          text
        }, i) => <li key={title} className={`flex items-start gap-3 p-4 sm:gap-5 sm:p-6 md:items-center md:p-7 ${i > 0 ? 'border-t border-line' : ''} ${i === 0 ? 'bg-gold-light/60' : ''}`} data-id="element-99" data-mp="25l2ekmq38g8d" data-mpi={i}>
              <span className="w-5 font-serif text-2xl font-semibold leading-none text-gold sm:text-3xl md:w-8" data-id="element-100" data-mp="1rmm6osghojon">{i + 1}</span>
              <Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark sm:h-6 sm:w-6 md:mt-0" aria-hidden="true" data-id="element-101" data-mp="1mmzl9vqibx4r" />
              <div className="flex-1" data-id="element-102" data-mp="2d34bgro5xsoe">
                <h3 className="font-serif text-xl font-semibold leading-tight text-ink sm:text-2xl" data-id="element-103" data-mp="2d22qnvhchrth">
                  {title}
                  {i === 0 && <span className="ml-2 align-middle font-sans text-[10px] font-bold uppercase tracking-wider text-gold-dark sm:ml-3 sm:text-xs" data-id="element-104" data-mp="244ip0lfkltic">
                      Principal
                    </span>}
                </h3>
                <p className="mt-1 text-sm text-muted sm:text-base" data-id="element-105" data-mp="2vsu7fi3nwkhw">{text}</p>
              </div>
            </li>)}
        </ol>
        <p className="mt-5 text-center text-sm font-bold text-ink sm:mt-6 sm:text-base" data-id="element-106" data-mp="2murymgdosnk2">
          4 recursos digitales para acompañar tu fe, tu estudio y tu crecimiento interior.
        </p>

        <div className="mx-auto mt-14 max-w-2xl text-center md:mt-20" data-id="element-107" data-mp="1beacb93t01b5">
          <h2 className="font-serif text-[1.9rem] font-semibold leading-tight text-ink sm:text-4xl md:text-5xl" data-id="element-108" data-mp="1gdwpxjnjnjkh">
            Empezá hoy a dedicarle más tiempo a tu fe
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-ink/80 sm:text-lg md:mt-6" data-id="element-109" data-mp="3i56lwj8kp4gs">
            No necesitás esperar al domingo, a un momento difícil o a que todo esté en orden para acercarte a la Palabra.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-muted sm:text-lg md:mt-4" data-id="element-110" data-mp="34bxh6vvkl74l">
            Podés empezar hoy, con unos minutos de lectura, una oración sincera y la intención de seguir creciendo.
          </p>
        </div>
      </div>
    </section>;
}